'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
<div className={`fixed bottom-6 left-0 right-0 mx-auto z-50 floating-cta w-[calc(100%-2rem)] max-w-sm sm:w-auto ${visible ? 'visible' : ''}`}>
  <div
    className="flex gap-2 sm:gap-3 px-3 sm:px-4 py-2 sm:py-3 rounded-full"
    style={{
      background: "rgba(255,255,255,0.95)",
      border: "1px solid rgba(30,111,217,0.2)",
      boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
      backdropFilter: "blur(12px)",
    }}
  >
    <a
      href="tel:+32496538283"
      className="flex flex-1 items-center justify-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2 rounded-full font-bold text-xs sm:text-sm transition-all duration-300 hover:scale-105"
      style={{ background: "#16A34A", color: "white" }}
    >
      <Icon name="PhoneIcon" size={15} className="text-white" />
      0496 53 82 83
    </a>

    <div
      className="hidden sm:block w-[1px] h-10"
      style={{ background: "rgba(0,0,0,0.1)" }}
    />

    <a
      href="https://wa.link/kusumk"
      target="_blank"
      rel="noopener noreferrer"
      className="flex flex-1 items-center justify-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2 rounded-full font-bold text-xs sm:text-sm transition-all duration-300 hover:scale-105"
      style={{
        background: "rgba(34,197,94,0.12)",
        color: "#16A34A",
        border: "1px solid rgba(34,197,94,0.25)",
      }}
    >
      <Icon
        name="ChatBubbleLeftRightIcon"
        size={15}
        style={{ color: "#16A34A" }}
      />
      WhatsApp
    </a>
  </div>
</div>
  );
}